export function YearNavigation({
    year,
    onYearChange,
}: {
    year: number;
    onYearChange?: (year: number) => void;
}) {
    const SIDE_LENGTH = 300;
    const radius = SIDE_LENGTH / 2.5;
    const sideLength = SIDE_LENGTH;
    const center = sideLength / 2;

    const topSize = radius / 4;
    const botSize = radius / 10;
    const gap = (topSize + botSize) / 4;

    const arrowOffset = 60;

    return (
        <>
            <g cursor="pointer" onClick={() => onYearChange?.(year - 1)}>
                <circle
                    cx={center - arrowOffset}
                    cy={center - gap}
                    r={20}
                    fill="transparent"
                    stroke="transparent"
                    strokeWidth={2}
                    className="hover:fill-chameleon-green/15 hover:stroke-chameleon-green/40"
                />
                <text
                    x={center - arrowOffset}
                    y={center - gap}
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontSize={topSize}
                    className="fill-chameleon-green"
                    pointerEvents="none"
                >
                    ‹
                </text>
            </g>

            <text
                x={center}
                y={center - gap}
                textAnchor="middle"
                dominantBaseline="middle"
                fontSize={topSize}
                className="fill-chameleon-green"
                pointerEvents="none"
            >
                {year}
            </text>

            <g cursor="pointer" onClick={() => onYearChange?.(year + 1)}>
                <circle
                    cx={center + arrowOffset}
                    cy={center - gap}
                    r={20}
                    fill="transparent"
                    stroke="transparent"
                    strokeWidth={2}
                    className="hover:fill-chameleon-green/15 hover:stroke-chameleon-green/40"
                />
                <text
                    x={center + arrowOffset}
                    y={center - gap}
                    textAnchor="middle"
                    dominantBaseline="middle"
                    fontSize={topSize}
                    className="fill-chameleon-green"
                    pointerEvents="none"
                >
                    ›
                </text>
            </g>

            <text
                x={center}
                y={center + gap}
                textAnchor="middle"
                dominantBaseline="middle"
                fontSize={botSize}
                className="fill-text-on-bone"
            >
                HSE&Q
            </text>
        </>
    );
}
